import { Meta } from "../partials/meta";

export default function Home() {
    return (
        <>
            <Meta title="A Web Development Company" description="We've been handcrafting code since 2000..."/>
            <h1>We have been doing stuff for quite a while...</h1>
        </>
    );
}